import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function SeoSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="lg:w-[25%] w-full">
            <span className="inline-block px-4 py-2 rounded-full border border-foreground-300 text-sm font-medium text-foreground-600 bg-background-50 whitespace-nowrap">
              {t('seo.tag')}
            </span>
            <div className="mt-8 w-full aspect-[3/4] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Floor%20to%20ceiling%20mahogany%20bookshelf%20in%20classic%20library%20study%20filled%20with%20organized%20leather%20bound%20books%20and%20reference%20materials%2C%20vintage%20brass%20reading%20lamp%20casting%20warm%20pool%20of%20light%20on%20open%20laptop%20and%20handwritten%20notes%20on%20oak%20desk%2C%20scholarly%20academic%20atmosphere%20with%20dusty%20sunbeams%2C%20intellectual%20editorial%20photography%20with%20rich%20brown%20and%20gold%20tones&width=800&height=1066&seq=seo-collage-v2-2026&orientation=portrait"
                alt="Kakobuy Spreadsheet przewodnik SEO"
                title="Kakobuy Spreadsheet przewodnik SEO"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:w-[75%] w-full">
            <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              {t('seo.title1')}<br />
              {t('seo.title2')}<br />
              {t('seo.title3')}
            </h2>
            <p className="mt-6 text-base md:text-lg text-foreground-500 leading-relaxed max-w-2xl">
              {t('seo.description')}
            </p>
            <Link
              to="/kakobuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 mt-8 bg-primary-500 text-background-50 px-7 py-3.5 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              {t('seo.cta')}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}